document.addEventListener("DOMContentLoaded", () => {
    const inputsProduct = Array.from(document.querySelectorAll(".swatchInput"));
    const inputYes = inputsProduct.find(input => input.value === "YES");
    const inputNo = inputsProduct.find(input => input.value === "NO");

    function verificarVarianteSelecionada() {
        if (inputYes && inputYes.checked) {
            document.getElementById("aparecer").style.display = "block";
            document.getElementById('nomecamisa').required = true;
            document.getElementById('numcamisa').required = true;
        } else {
            document.getElementById("aparecer").style.display = "none";
            document.getElementById('nomecamisa').required = false;
            document.getElementById('numcamisa').required = false;
        }
    }

    if (inputYes) {
        inputYes.addEventListener("change", verificarVarianteSelecionada);
    }

    if (inputNo) {
        inputNo.addEventListener("change", verificarVarianteSelecionada);
    }

    // Verificar se algum input "YES" já está marcado ao carregar a página
    verificarVarianteSelecionada();
});
